import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { Badge } from "@/components/common/DataTable";

export default function PermissionsPage() {
  const [grouped, setGrouped] = useState({});
  useEffect(() => {
    api.get("/v1/permissions/catalogue").then((r) => setGrouped(r.data.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="permissions-page">
      <PageHeader title="Permission Catalogue" subtitle="All MODULE.ACTION permissions in the platform (read-only)" />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(grouped).map(([module, perms]) => (
          <div key={module} className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm">
            <h3 className="font-semibold text-slate-800 mb-3 font-mono text-sm">{module}</h3>
            <div className="flex flex-wrap gap-1.5">
              {perms.map((p) => (
                <Badge key={p} color="teal">{p.split(".")[1]}</Badge>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
